var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 12.25C21.875 18.375 14 23.625 14 23.625C14 23.625 6.125 18.375 6.125 12.25C6.125 10.1614 6.95469 8.15838 8.43153 6.68153C9.90838 5.20469 11.9114 4.375 14 4.375C16.0886 4.375 18.0916 5.20469 19.5685 6.68153C21.0453 8.15838 21.875 10.1614 21.875 12.25Z",
    stroke: "#8F90A6",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.875C15.4497 14.875 16.625 13.6997 16.625 12.25C16.625 10.8003 15.4497 9.625 14 9.625C12.5503 9.625 11.375 10.8003 11.375 12.25C11.375 13.6997 12.5503 14.875 14 14.875Z",
    stroke: "#8F90A6",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSecondary);
export default __webpack_public_path__ + "static/media/location-secondary.84cb8959267524024dc0697dccb98022.svg";
export { ForwardRef as ReactComponent };